
import parseXlsx from './xlsx-parser';

function parseFileExcelFile(file, lang, sheetNumber, callback) {
    const reader = new FileReader();

    reader.onload = event =>
        parseXlsx(event.target.result, lang, sheetNumber)
            .then(result => callback(result))
            .catch(error => callback(error));

    if (file.type === 'text/csv') {
        reader.readAsText(file);
    } else {
        reader.readAsBinaryString(file);
    }
}


export default (htmlFile, lang, sheetNumber) =>
    new Promise((resolve, reject) => {
        parseFileExcelFile(htmlFile, lang, sheetNumber, (result) => {
            if (result.error) {
                return reject(result.error);
            }
            return resolve(result.worksheet);
        });
    });
